import { empty, singleton, enumerateWhile, append, delay } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { clear, getEnumerator } from "../fable_modules/fable-library-js.4.24.0/Util.js";

/**
 * Split a sequence into chunks, where a new chunk starts each time the <paramref name="predicate"/> returns <c>true</c>.
 */
export function splitWhen(predicate, items) {
    return delay(() => {
        const e = getEnumerator(items);
        if (e["System.Collections.IEnumerator.MoveNext"]()) {
            const a = [];
            void (a.push(e["System.Collections.Generic.IEnumerator`1.get_Current"]()));
            return append(enumerateWhile(() => e["System.Collections.IEnumerator.MoveNext"](), delay(() => append(predicate(e["System.Collections.Generic.IEnumerator`1.get_Current"]()) ? append(singleton(a.slice()), delay(() => {
                clear(a);
                return empty();
            })) : empty(), delay(() => {
                void (a.push(e["System.Collections.Generic.IEnumerator`1.get_Current"]()));
                return empty();
            })))), delay(() => singleton(a.slice())));
        }
        else {
            return empty();
        }
    });
}

